import {Box, Typography} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';

type Props = {
  password: string;
  repeatPassword?: string;
  onPasswordValid: () => void;
  onPasswordInvalid: () => void;
};

export function PasswordChecker(props: Props) {
  const {password, repeatPassword, onPasswordValid, onPasswordInvalid} = props;
  const {t} = useTranslation();
  const checkLength = password.length >= 8;
  const checkUppercase = /[A-Z]/.test(password);
  const checkLowercase = /[a-z]/.test(password);
  const checkSpecialChar = /[\^$*.[\]{}()?"!@#%&/\\,><':;|\-=_~`]/.test(password);
  const checkNumber = /\d/.test(password);
  // Deux champs vides ne sont pas « identiques » : la règle restait cochée avant toute saisie.
  const samePassword = password !== '' && password === repeatPassword;

  React.useEffect(() => {
    if (checkLength && checkUppercase && checkLowercase && checkSpecialChar && checkNumber && password) {
      onPasswordValid();
    } else {
      onPasswordInvalid();
    }
  }, [password, repeatPassword]);

  return (
    <Box style={{display: 'flex', flexDirection: 'row'}}>
      <Box style={{display: 'flex', flexDirection: 'column', textAlign: 'left'}}>
        <Typography variant="caption" color={checkLength ? 'primary' : 'error'}>
          {checkLength ? <span>✅ </span> : <span>❌ </span>}
          {t('passwordchecker.length')}
        </Typography>
        <Typography variant="caption" color={checkUppercase ? 'primary' : 'error'}>
          {checkUppercase ? <span>✅ </span> : <span>❌ </span>}
          {t('passwordchecker.upperCaseLetters')}
        </Typography>
        <Typography variant="caption" color={checkLowercase ? 'primary' : 'error'}>
          {checkLowercase ? <span>✅ </span> : <span>❌ </span>}
          {t('passwordchecker.lowerCaseLetters')}
        </Typography>
      </Box>
      <Box style={{display: 'flex', flexDirection: 'column', marginLeft: 10, textAlign: 'left'}}>
        <Typography variant="caption" color={checkSpecialChar ? 'primary' : 'error'}>
          {checkSpecialChar ? <span>✅ </span> : <span>❌ </span>}
          {t('passwordchecker.specialChars')}
        </Typography>
        <Typography variant="caption" color={checkNumber ? 'primary' : 'error'}>
          {checkNumber ? <span>✅ </span> : <span>❌ </span>}
          {t('passwordchecker.digits')}
        </Typography>
        <Typography variant="caption" color={samePassword ? 'primary' : 'error'}>
          {samePassword ? <span>✅ </span> : <span>❌ </span>}
          {t('passwordchecker.repeatPassword')}
        </Typography>
      </Box>
    </Box>
  );
}
